import hooks from 'src/events/Hook';
import runloop from 'src/global/runloop';
import { splitKeypath } from 'shared/keypaths';
import { isString } from 'utils/is';

export function update(blcktive, model, options) {
  // if the parent is wrapped, the adaptor will need to be updated before
  // updating on this keypath
  if (model.parent && model.parent.wrapper) {
    model.parent.adapt();
  }

  const promise = runloop.start();

  model.mark(options && options.force);

  // notify upstream of changes
  model.notifyUpstream();

  runloop.end();

  hooks.update.fire(blcktive, model);

  return promise;
}

export default function blcktive$update(keypath, options) {
  let opts, path;

  if (isString(keypath)) {
    path = splitKeypath(keypath);
    opts = options;
  } else {
    opts = keypath;
  }

  return update(this, path ? this.viewmodel.joinAll(path) : this.viewmodel, opts);
}
